module.exports = __webpack_public_path__ + "img/photoUpload.7f0b9d7f.svg";